import React, { useState, useEffect, useMemo } from 'react';
import { BlockTitle, BlockMore } from '../HomePage';
import apiClient from '../../_utils/axios';
import Store from 'store';
import RenderThumbs from './renderThumbs';
import { InView } from 'react-intersection-observer';
import { useHistory } from 'react-router-dom';
import { getStringByLang } from '../../libs/lang';
import { useNewDesign } from '../../hooks/useNewDesign';
import { useHomePageContext } from '../../context/HomePageContext';

export const NewDesign = ({ interest_list }) => {
  const { state: home_state, actions: home_actions } = useHomePageContext();
  const { state, actions } = useNewDesign();

  const currnetTitle = useMemo(() => {
    return getStringByLang(
      home_state.config.main_title_1_ko,
      home_state.config.main_title_1_en,
      home_state.config.main_title_1_jp,
    );
  }, [home_state.config]);

  const RenderedThumbs = () => {
    return (
      <RenderThumbs
        thumbList={state.data.designList}
        interest_list={interest_list}
        largeCount={15}
        middleCount={12}
        middleSmallCount={6}
        mallCount={6}
        main_title={currnetTitle}
        ShowBasketModal={home_actions.ShowBasketModal}
        setStateAsync={home_actions.setUI}
        setData={(newData) => actions.setData({ designList: [...newData] })}
      />
    );
  };

  return (
    <InView>
      <div style={{ marginTop: '3vw' }}>
        <BlockTitle>{currnetTitle}</BlockTitle>
        <BlockMore onClick={actions.goMoreDesign} />
        <RenderedThumbs />
      </div>
    </InView>
  );
};

export default NewDesign;
